import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpCommissionsPage() {
  const t = useTranslations('galleries_help.commissions');
  const [openSections, setOpenSections] = useState({
    overview: false,
    tierRules: false,
    programsGlance: false,
    bestRate: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('overview')}
            aria-expanded={openSections.overview}
          >
            <h2>{t('sections.overview.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.overview ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.overview && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.overview.p1')}</p>
              <p>{t('sections.overview.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('tierRules')}
            aria-expanded={openSections.tierRules}
          >
            <h2>{t('sections.tier_rules.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.tierRules ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.tierRules && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.tier_rules.in_platform_sales.title')}</h3>
                <p>{t('sections.tier_rules.in_platform_sales.p1')}</p>
                <p>{t('sections.tier_rules.in_platform_sales.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.tier_rules.subscriptions_support.title')}</h3>
                <p>{t('sections.tier_rules.subscriptions_support.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.tier_rules.limited_editions_other_products.title')}</h3>
                <p>{t('sections.tier_rules.limited_editions_other_products.p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('programsGlance')}
            aria-expanded={openSections.programsGlance}
          >
            <h2>{t('sections.programs_glance.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.programsGlance ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.programsGlance && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <ul>
                <li>{t('sections.programs_glance.list_1')}</li>
                <li>{t('sections.programs_glance.list_2')}</li>
                <li>{t('sections.programs_glance.list_3')}</li>
                <li>{t('sections.programs_glance.list_4')}</li>
                <li>{t('sections.programs_glance.list_5')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('bestRate')}
            aria-expanded={openSections.bestRate}
          >
            <h2>{t('sections.best_rate.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.bestRate ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.bestRate && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.best_rate.p1')}</p>
              <p>{t('sections.best_rate.p2')}</p>
              <p>{t('sections.best_rate.p3')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
